export function getClassForSeat(b, customClass, seatType, isAvailable, isSelected, isFriend, isHouse) {
    const availability = getSeatAvailabilityClassModifier(isAvailable, isSelected);
    const modifiers = {
        [seatType]: true,
        [availability]: true,
        friend: isFriend,
        house: isHouse
    };
    return b.block(modifiers, customClass);
}
function getSeatAvailabilityClassModifier(isAvailable, isSelected) {
    if (isSelected) {
        return 'selected';
    }
    return isAvailable ? 'available' : 'unavailable';
}
//# sourceMappingURL=get-class-for-seat.js.map